import { Box, Card, Grid, Typography } from "@mui/material";
import { useState } from "react";
import DataTable, { Column } from "../components/dataTable";
import { useDashboard } from "../../StateManagement/dashboardContext";
import { useNavigate } from "react-router-dom";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import DashboardChart from "./DashboardChart";
// import { callAPI, Method } from "../../commonFunctions/CommonFunctions";

function DashboardTables({ loading }: { loading: boolean }) {
  const { tables, charts } = useDashboard();

  // const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);

  // topCollectors
  // const fetchTopTables = async () => {
  //   try {
  //     const res = await callAPI("dashboards/top/branches", Method.GET);
  //     console.log("table data", res);
  //     // setTableData(res.data);
  //   } catch (error: any) {
  //     console.error(error.response?.data?.message || 'Fetch failed, please try again!')
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchTopTables();
  // }, []);

  const navigate = useNavigate();

  const loanColumns: Column[] = [
    { field: "loanId", label: "Loan ID" },
    // { field: "applicantName", label: "Applicant" },
    {
      label: "Enterprise",
      field: "enterpriseName",
    },
    { field: "mobile", label: "Mobile" },
    { field: "appliedAmount", label: "Applied Amount", type: "currency" },
    { field: "status", label: "Status", type: "status" },
  ];

  const RepaymentColumns: Column[] = [
    { field: "receiptNumber", label: "Receipt NO:" },
    { field: "paymentType", label: "Payment Method" },
    { field: "amount", label: "Paid Amount", type: "currency" },
    { field: "collector.role", label: "Collected By" },
    { field: "collector.name", label: "Collector" },
  ];

  const CollectorsColumns: Column[] = [
    { field: "name", label: "Name" },
    { field: "count", label: "Total Count", type: "number" },
    { field: "role", label: "Role" },
    { field: "totalAmount", label: "Total Amount", type: "currency" },
  ];

  const BlockColumns: Column[] = [
    { field: "blockName", label: "Block Name" },
    { field: "totalCollection", label: "Total Collection", type: "currency" },
  ];

  const handleLoanView = (data: any) => {
    navigate(`/loan/detail/${data?._id}`);
  };

  const handleRepaymentView = (data: any) => {
    navigate(`/loan/repayment/requests/list/filter/${data?._id}`)
  }

  const loanactions = [{ label: "View", handler: handleLoanView }];
  const repaymentActions = [{ label: "View", handler: handleRepaymentView }]

  return (
    <>
      <Grid container spacing={2} p={2} alignItems="stretch">
        {tables.recentLoans.length > 0 && (
          <Grid item xs={12} md={8}>
            <Box height="100%">
              <DataTable
                title="Recent Loans"
                columns={loanColumns}
                data={tables.recentLoans}
                loading={loading}
                onPageChange={setPage}
                actions={loanactions}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                page={page}
                totalPages={totalPages}
                exportToExcel
              />
            </Box>
          </Grid>
        )}

        {charts.paymentMethodStats.length > 0 && (
          <Grid item xs={12} md={4}>
            <Card
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 2,
                boxShadow: 1,
                height: "100%", // Ensure it stretches to fill available space
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="h6"
                fontWeight={600}
                mb={2}
                color="text.primary"
                textAlign="center"
              >
                Payment Method Distribution
              </Typography>
              <Box sx={{ flexGrow: 1 }}>
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={charts.paymentMethodStats}
                      dataKey="count"
                      nameKey="_id"
                      cx="50%"
                      cy="50%"
                      outerRadius={100}
                      label={({
                        name,
                        cx,
                        cy,
                        midAngle,
                        innerRadius,
                        outerRadius,
                        percent,
                        index,
                      }) => {
                        const RADIAN = Math.PI / 180;
                        const radius = 25 + outerRadius;
                        const x = cx + radius * Math.cos(-midAngle * RADIAN);
                        const y = cy + radius * Math.sin(-midAngle * RADIAN);

                        return (
                          <text
                            x={x}
                            y={y}
                            fill="#333"
                            textAnchor={x > cx ? "start" : "end"}
                            dominantBaseline="central"
                          >
                            {charts.paymentMethodStats[index]._id} (
                            {(percent * 100).toFixed(0)}%)
                          </text>
                        );
                      }}
                      paddingAngle={3}
                    >
                      {charts.paymentMethodStats.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={
                            [
                              "#08B1B6",
                              "#4AD06E",
                              "#E5EAFC",
                              "#4BC0C0",
                              "#9966FF",
                            ][index % 5]
                          }
                        />
                      ))}
                    </Pie>
                    <Tooltip
                      contentStyle={{ backgroundColor: "#fff", borderRadius: 8 }}
                      labelStyle={{ fontWeight: 500 }}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </Box>
            </Card>
          </Grid>
        )}
      </Grid>


      <DashboardChart />

      <Grid container spacing={2} p={2} mb={6}>
        {/* repayment tables */}
        {tables.recentRepayments.length > 0 && (
          <Grid item xs={12}>
            <DataTable
              title="Recent Repayments"
              columns={RepaymentColumns}
              data={tables.recentRepayments}
              loading={loading}
              onPageChange={setPage}
              actions={repaymentActions}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              page={page}
              totalPages={totalPages}
              exportToExcel
            />
          </Grid>
        )}
        {/* Left: Top Collectors */}
        {tables.topCollectors.length > 0 && (
          <Grid item xs={12} md={6}>
            <DataTable
              title="Top Collectors"
              columns={CollectorsColumns}
              data={tables.topCollectors}
              loading={loading}
              onPageChange={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              page={page}
              totalPages={totalPages}
              exportToExcel
            />
          </Grid>
        )}

        {/* Right: Collected by Blocks */}
        {tables.collectionByBlocks.length > 0 && (
          <Grid item xs={12} md={6}>
            <DataTable
              title="Collected by Blocks"
              columns={BlockColumns}
              data={tables.collectionByBlocks}
              loading={loading}
              onPageChange={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              page={page}
              totalPages={totalPages}
              exportToExcel
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default DashboardTables;